import { render, staticRenderFns } from "./MoveFriendDialog.vue?vue&type=template&id=1c0a7d83"
import script from "./MoveFriendDialog.vue?vue&type=script&lang=js"
export * from "./MoveFriendDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports